import { render, staticRenderFns } from "./ObjectRemoverDetail.vue?vue&type=template&id=71063bc2&scoped=true"
import script from "./ObjectRemoverDetail.vue?vue&type=script&lang=js"
export * from "./ObjectRemoverDetail.vue?vue&type=script&lang=js"
import style0 from "./ObjectRemoverDetail.vue?vue&type=style&index=0&id=71063bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71063bc2",
  null
  
)

export default component.exports